import { Methods } from '@newview/infrastructure';
import {BasicDataBaseApi} from "./BasicDataBaseApi";


export class CodesubprojectrelationApi extends BasicDataBaseApi {

  public get ControllerName(): any {
    return 'codesubprojectrelation'
  }

  /**
   * 查询编码组件列表
   * @param params
   */
  public getList(params){
    return this.send(params,"getList",Methods.GET)
  }

  /**
   * 批量保存关系
   * @param param 
   */
  public saveRelations(param){
    return this.send(param,"saveRelations",Methods.POST)
  }
  /**
   * 编码id查询关系列表
   * @param codeComponentsId 
   */
  public getListByComponentsId(codeComponentsId){
    return this.send({codeComponentsId:codeComponentsId},"getListByComponentsId",Methods.GET)
  } 

}